import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { distinctUntilChanged, map } from 'rxjs/operators';
import _ from 'lodash';
import { SamwinUserConfigurationState } from 'src/app/store/samwin/samwin-user-configuration/samwin-user-configuration.state';
import { SamwinUserShortInfoRemoteDto } from 'src/generated/signalR/samwin-user-short-info-remote-dto';

@Pipe({
   name: 'userIdToUserShortInfo$',
})
export class UserIdToUserShortInfoPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(userId: number): Observable<SamwinUserShortInfoRemoteDto> {
      return this.store.select(SamwinUserConfigurationState.getUserConfigurationFn).pipe(
         map((fn) => fn(userId)),
         distinctUntilChanged((prev, curr) => _.isEqual(prev, curr))
      );
   }
}
